import styled, { css } from 'styled-components'
import { white, gray, grayDark, grayDarker } from '@bufferapp/ui/style/colors'

import { flexRow, flexCol } from '~/shared/styles/layout'
import { baseFont } from '~/shared/styles/font'

export const PICKER_HEIGHT = 300
export const PICKER_CONTROLS_HEIGHT = 84
export const PICKER_MARGIN = 8
export const PICKER_BUTTON_HEIGHT = 32
export const PICKER_SKIN_SELECTOR_HEIGHT = 32

/**
 *
 */
function calcPickerHeigth(position = null) {
  if (!position) return PICKER_HEIGHT

  // @ts-expect-error TS(2339) FIXME: Property 'maxHeight' does not exist on type 'never... Remove this comment to see the full error message
  return Math.min(PICKER_HEIGHT, parseInt(position.maxHeight))
}

function calcPickerPosition(position = null) {
  if (!position) return 0

  const { direction, maxHeight } = position

  const pickerHeight = calcPickerHeigth(position)
  const controlHeight = PICKER_BUTTON_HEIGHT + PICKER_MARGIN

  return direction === 'top'
    ? (pickerHeight + PICKER_MARGIN) * -1
    : controlHeight
}

const buttonHover = css`
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  color: ${grayDarker};
`

const emojiPickerStyles = css`
  .emoji-mart {
    border-radius: 5px;
    box-shadow: none;
    border: none;
    background: none;
  }

  .emoji-mart-category-label {
    display: none;
  }

  .emoji-mart-category .emoji-mart-emoji span,
  .emoji-mart-anchor {
    cursor: pointer;
  }

  .emoji-mart-scroll {
    height: ${(props) =>
      // @ts-expect-error TS(2339) FIXME: Property 'position' does not exist on type 'ThemeP... Remove this comment to see the full error message
      calcPickerHeigth(props.position) -
      PICKER_CONTROLS_HEIGHT -
      PICKER_SKIN_SELECTOR_HEIGHT}px;
    border-radius: 8px;
    overflow-y: auto;
  }

  .emoji-mart-no-results {
    padding: 0px;
  }

  .emoji-mart-preview {
    height: ${PICKER_SKIN_SELECTOR_HEIGHT}px;
  }

  .emoji-mart-preview-skins {
    right: 14px;
    display: flex;
  }

  .emoji-mart-preview-skins:before {
    content: 'Skin color';
    margin-right: 8px;
    ${baseFont}
    color: ${grayDark};
  }

  .emoji-mart-skin-swatches {
    cursor: pointer;
  }
`

/**
 *
 */
export const Wrapper = styled.div`
  position: relative;
  width: 100%;
`

export const List = styled.ul`
  ${flexRow}
  justify-content: flex-end;
  width: 100%;
`

export const ListItem = styled.li`
  ${flexCol}
  justify-content: center;
  width: 32px;
  height: 32px;
  margin-left: 8px;
  border-radius: 50%;
  background-color: ${white};
  cursor: pointer;
  box-shadow: none;
  user-select: none;
  color: ${gray};

  ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'selected' does not exist on type 'Themed... Remove this comment to see the full error message
    props.selected && buttonHover};

  &:hover {
    ${buttonHover}
  }
`

// NOTE: With a minimum font size of 26px the emojis are centred on
// retina and not retina screens. Then scale down to whatever size is
// needed. This will remove the white space that appears at the right
// side of emojis.
export const Emoji = styled.span`
  font-size: 26px;
  transform: scale(0.6);
  margin-top: 2px;
`

export const IconWrapper = styled.div`
  width: 100%;
  height: 100%;
  transform-origin: 25% 50%;
  transform: rotate(90deg);
`

export const PickerWrapper = styled.div`
  display: ${(props) =>
    // @ts-expect-error TS(2339) FIXME: Property 'visible' does not exist on type 'ThemedS... Remove this comment to see the full error message
    props.visible ? 'block' : 'none'};
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 5px;
  border: 1px solid ${gray};
  background-color: ${white};
  width: 304px;
  height: ${(props) =>
    calcPickerHeigth(
      // @ts-expect-error TS(2339) FIXME: Property 'position' does not exist on type 'Themed... Remove this comment to see the full error message
      props.position,
    ) + 4}px;
  position: absolute;
  top: ${(props) =>
    calcPickerPosition(
      // @ts-expect-error TS(2339) FIXME: Property 'position' does not exist on type 'Themed... Remove this comment to see the full error message
      props.position,
    )}px;
  right: 0px;
  z-index: 1000;
  ${emojiPickerStyles}
`
